// Browser stand-in for write-file-atomic. There's no atomic rename in the
// FSA/OPFS world, so this just writes through the fs layer. The deployment
// manifest backup uses the synchronous `sync` export; our fs is async-only,
// so `sync` does a best-effort fire-and-forget write (the backup is
// non-critical — the primary manifest is written by util/fsAtomic). Without
// this, `write-file-atomic` resolves to an empty object and
// `(0, empty.sync) is not a function` is logged on every deploy.
const fsPromises = require("./fs-promises.cjs");

function writeFileAtomic(file, data, options, callback) {
    if (typeof options === "function") {
        callback = options;
    }
    const p = fsPromises.writeFile(file, data);
    if (typeof callback === "function") {
        p.then(
            () => callback(null),
            (err) => callback(err),
        );
        return undefined;
    }
    return p;
}

function sync(file, data) {
    // can't write synchronously to async FSA/OPFS; best-effort async write
    fsPromises.writeFile(file, data).catch(() => undefined);
}

writeFileAtomic.sync = sync;

module.exports = writeFileAtomic;
module.exports.default = writeFileAtomic;
module.exports.sync = sync;
